<script>
  export default {
    name: 'BaseButton',

    props: {
      primary: {
        type:    Boolean,
        default: false,
      },

      subtle: {
        type:    Boolean,
        default: false,
      },

      disabled: {
        type:    Boolean,
        default: false,
      },
    },

    computed: {
      baseClasses () {
        return {
          'button':          true,
          'button-primary':  this.primary,
          'button-subtle':   this.subtle,
          'button-disabled': this.disabled,
        };
      },
    },
  };
</script>

<!--suppress CssFloatPxLength -->
<style>
    .button {
        -webkit-appearance: none;
        padding:            0.5rem 1rem;
        border:             none;
        border-radius:      4px;
        background:         var(--color-gray-light);
        outline:            none;
        user-select:        none;
        cursor:             pointer;
        font-family:        inherit;
        font-size:          1rem;
        text-transform:     uppercase;
        letter-spacing:     0.5px;
        font-weight:        500;
        transition:         all 250ms;
    }

    .button.button-primary {
        background:  var(--color-primary);
        color:       var(--color-white);
        text-shadow: -1px -1px 0 rgba(0, 0, 0, 0.1);
    }

    .button.button-subtle {
        background:  transparent;
        color:       var(--color-gray-dark);
    }

    .button:hover,
    .button:focus {
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .button.button-subtle:hover,
    .button.button-subtle:focus {
        box-shadow: none;
        background: var(--color-gray-lighter);
        color:      var(--color-primary);
    }

    .button.button-disabled {
        pointer-events: none;
        background:     var(--color-gray);
    }
</style>
